export enum SagaStatus {
  Pending = 'pending',
  Completed = 'completed',
}
